import React, { Component } from 'react';
import MaterialTable from 'material-table';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import {
  getMedicalTreatment,
  getMTTypes,
  handleEditMTRecordOpenDialog,
  handleEditMTRecordCloseDialog,
  downloadMedicalTreatmentRecord
} from "../../actions/MedicalTreatment";
import AddMTRecord from './AddMedicalTreatment';

import SGMaterialTable from '../../components/UI/Table/SGMaterialTable';
import {apiUrl} from "../../config";

import {
  GetUrl
}from "../../utils/Helper";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ListMedicalTreatment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      mtColumns: [
        {
          title: 'MT Types',
          field: 'mt_type'
        },
        {
          title: 'Treatment Date',
          field: 'treatment_date'
        },
        {
          title: 'Next Treatment Date',
          field: 'next_treatment_date'
        },
        {
          title: 'Notification Date',
          field: 'notification_date'
        },
        {
          title: 'Medical Certificate',
          field: 'medical_certificate',
          render: rowData =>
            <a
              href="javascript:void(0);"
              style={{ color: "blue" }}
              onClick={() => this.setState({ openDialog: true, docUrl: GetUrl(apiUrl + "/businesses/"+localStorage.getItem('business_id')+"/drivers/"+localStorage.getItem('driver_id')+"/records/"+rowData.recordId) })}
            >
              {rowData.medical_certificate}
            </a>
        },
        {
          title: 'MT Require',
          field: 'mt_requires',
          lookup: {
            true: 'Yes',
            false: 'No'
          },
        },
      ],
    }
  }
  componentDidMount() {
    this.props.getMedicalTreatment();
    this.props.getMTTypes();
  }
  navigateToAddMTRecord(url) {
    let actulaURL = '';
    if (url.indexOf(":driverid") >= 0) {
      actulaURL = url.replace(":driverid", localStorage.getItem('driver_id'));
    }
    if (actulaURL !== '') {
      url = actulaURL;
    }
    this.props.history.push(url);
  }
  handleClose =()=>{
    this.setState({openDialog:false})
  }
  render() {
    let {
      mtInformations,
      editMTRecordDialogStatus,
      mtTypeLookUp,
      showMTRecordListLoaderStatus,
    } = this.props.medicalTreatmentState;
    let {
      menuItems
    } = this.props.sidebarState;
    this.state.mtColumns[0].lookup = mtTypeLookUp;
    return (
      <div className="container mt-3">
        <Paper>
          <Grid container spacing={24} style={{ paddingLeft: "1rem", paddingTop: "0", paddingRight: "1rem" }}>
            <Grid item xs={6} style={{ paddingTop: "0" }}>
              <h4 style={{ marginTop: "1rem", textTransform: "uppercase" }}>Driver MT Detail List</h4>
            </Grid>
            <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "2rem" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.navigateToAddMTRecord(menuItems['medical_treatment_add'].urlpattern)}
              >
                <i className="material-icons" style={{ paddingRight: "0.5rem" }}>
                  add_circle_outline
                              </i>
                Add MT Record
                          </Button>

            </Grid>
          </Grid>
          {
            showMTRecordListLoaderStatus ?
              <div style={{ height: "30rem" }} className="d-flex justify-content-center align-items-center">
                <CircularProgress color="primary" />
              </div> :
              <SGMaterialTable
                title=""
                columns={this.state.mtColumns}
                data={mtInformations}
                actions={[
                  {
                    icon: 'edit',
                    tooltip: 'Edit',
                    onClick: (event, rowData) => this.props.handleEditMTRecordOpenDialog(rowData)
                  }
                ]}
              />
          }

          <Dialog
            open={editMTRecordDialogStatus}
            onClose={() => { this.props.handleEditMTRecordCloseDialog() }}
            maxWidth='md'
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <AddMTRecord />
          </Dialog>
          <Dialog
            open={this.state.openDialog}
            TransitionComponent={Transition}
            onClose={window.setTimeout(() => {
              this.setState({openDialog: false});
           }, 5000)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">Loading Please Wait..</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {this.state.docUrl &&
                <embed src={this.state.docUrl} width="200px" height="150px" />

                }
          </DialogContentText>
            </DialogContent>
            {/* <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Close
          </Button>
            </DialogActions> */}
          </Dialog>
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    medicalTreatmentState: state.medicalTreatment,
    sidebarState: state.sidebarState
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getMedicalTreatment: (driverId) => {
      return dispatch(getMedicalTreatment(driverId))
    },
    getMTTypes: () => {
      return dispatch(getMTTypes())
    },
    handleEditMTRecordOpenDialog: (rowData) => {
      return dispatch(handleEditMTRecordOpenDialog(rowData))
    },
    handleEditMTRecordCloseDialog: () => {
      return dispatch(handleEditMTRecordCloseDialog())
    },
    downloadMedicalTreatmentRecord: (recordId, driverId) => {
      return dispatch(downloadMedicalTreatmentRecord(recordId, driverId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListMedicalTreatment));